/* ==========================================================================
   MONTAGE-THEME · Einlaufen beim Scrollen
   --------------------------------------------------------------------------
   Die Vorlagen blenden Inhalte weich ein, sobald sie ins Bild scrollen
   (AG1 .reveal, Loop animate-item). Hier dasselbe mit einem
   IntersectionObserver.

   Fortschrittliche Verbesserung, in dieser Reihenfolge:
     1. Ohne JavaScript ist ALLES sichtbar. Das Verstecken passiert erst,
        wenn dieses Skript das Wurzelattribut data-einlauf-bereit setzt,
        nie im Markup.
     2. Erst danach beobachtet der Observer die [data-einlauf-scroll]-
        Elemente und setzt data-sichtbar, wenn sie ins Bild kommen.
     3. prefers-reduced-motion schaltet den Effekt komplett ab (im CSS).

   Kurven aus den Vorlagen: 0.6s cubic-bezier(0.32, 0.72, 0, 1) (AG1)
   beziehungsweise cubic-bezier(0.28, 0.08, 0.22, 0.99) (Loop). Die
   Uebergaenge stehen in montage-sections.css, hier faellt nur der Schalter.
   ========================================================================== */
/* Gekapselt, weil mehrere Sektionen dieselbe Datei einbinden koennen. */
(function () {
  if (document.documentElement.hasAttribute('data-einlauf-bereit')) return;

  const elemente = document.querySelectorAll('[data-einlauf-scroll]');
  if (!elemente.length || !('IntersectionObserver' in window)) return;

  document.documentElement.setAttribute('data-einlauf-bereit', '');

  const beobachter = new IntersectionObserver(
    (eintraege) => {
      for (const e of eintraege) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-sichtbar', '');
          // Einmal sichtbar bleibt sichtbar: kein Flackern beim Zurueckscrollen.
          beobachter.unobserve(e.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  const offen = new Set();

  elemente.forEach((el) => {
    // Was beim Laden schon im Bild steht, laeuft nicht erst ein.
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.setAttribute('data-sichtbar', '');
    } else {
      offen.add(el);
      beobachter.observe(el);
    }
  });

  /* 🔴 Notbremse. Ab dem Moment, in dem data-einlauf-bereit steht, ist ALLES
     unsichtbar, was der Observer nicht freigibt. Faellt er aus, egal warum,
     ist die Seite leer statt unanimiert. Ein fehlender Effekt ist nichts, eine
     leere Seite ist alles. Deshalb zwei Netze:

     1. Ein passiver scroll-Horcher prueft dasselbe noch einmal von Hand.
     2. Nach 5 Sekunden wird freigegeben, was dann noch offen und im Bild ist.

     Beide entfernen sich selbst, sobald nichts mehr offen ist. */
  const freigeben = (el) => {
    el.setAttribute('data-sichtbar', '');
    beobachter.unobserve(el);
    offen.delete(el);
    if (!offen.size) aufraeumen();
  };

  const nachpruefen = () => {
    for (const el of [...offen]) {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) freigeben(el);
    }
  };

  const aufraeumen = () => {
    window.removeEventListener('scroll', nachpruefen);
    window.removeEventListener('resize', nachpruefen);
  };

  if (offen.size) {
    window.addEventListener('scroll', nachpruefen, { passive: true });
    window.addEventListener('resize', nachpruefen, { passive: true });
    window.setTimeout(nachpruefen, 5000);
  }
})();
